module.exports = __webpack_public_path__ + "41b6800d1d91507a109ccde6b60cfb29.svg";